import React from 'react';
import { FolderOpen, Layers } from 'lucide-react';

// Topic navigation for the Question Bank
export const TopicSidebar = ({ topics, value, onChange }) => {
  const items = [['all', 'All topics'], ...topics.map(t => [t, t]), ['__none__', 'No topic']];
  return (
    <aside className="lg:sticky lg:top-4 self-start" data-testid="qb-topic-sidebar">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2 flex items-center gap-1.5">
        <Layers className="h-3.5 w-3.5" /> Topics
      </p>
      <div className="flex lg:flex-col gap-1 overflow-x-auto pb-2 lg:pb-0">
        {items.map(([v, label]) => (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            className={`text-left whitespace-nowrap lg:whitespace-normal px-3 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors ${
              value === v ? 'bg-[#20acf6] text-white' : 'text-slate-700 hover:bg-slate-100'
            }`}
            data-testid={`qb-topic-${v === 'all' ? 'all' : v === '__none__' ? 'none' : v.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          >
            <FolderOpen className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{label}</span>
          </button>
        ))}
      </div>
    </aside>
  );
};
